import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const PhysicalMediumList = Loadable(lazy(() => import("features/physicalMedium/components/List")));
const PhysicalMediumPage = Loadable(lazy(() => import("features/physicalMedium/components/Page")));

const routes = {
  path: "physicalMedium",
  children: [
    { path: "", element: <PhysicalMediumList /> },
    { path: "add", element: <PhysicalMediumPage /> },
    { path: "edit/:physicalMediumID?", element: <PhysicalMediumPage /> },
  ],
};

export default routes;